<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-button type="primary" plain @click="() => switchShowData()">{{
          showChart ? '列表' : '图表'
        }}</el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="reportActionBO.ajax?cmd=vehicleMonthlyReport"
          :params="fullSearchData"
          bizName="车辆运营月报表"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage" v-show="!showChart">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'customerCode'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-if="scope.column.property !== 'customerCode'">
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.rows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
    <div
      style="opacity: 0; height: 1px; background: #ffffff"
      id="placeholderDiv"
    ></div>
    <section style="min-height: 250px" v-show="showChart">
      <section v-show="searchData.mode === 1">
        <Order ref="org" :width="placeholderDiv + 'px'" />
      </section>
      <section class="order-chart-box" v-show="searchData.mode === 2">
        <Order ref="month" :width="placeholderDiv + 'px'" />
      </section>
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import Order from './order';
import {
  vehicleMonthlyReport,
} from 'api/report';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    Order,
    TableSetting,
  },
  data () {
    return {
      showChart: false,
      searchData: {},
      placeholderDiv: 0,

      tableData: { // 表格相关数据
        loading: false,
        rows: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'dependTime', label: '月份', fixed: true },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'orderNum', label: '订单数量' },
          { prop: 'incomeFee', label: '订单收入（元）' },
          { prop: 'orderCost', label: '订单成本（元）' },
          { prop: 'oilFee', label: '油费' },
          { prop: 'etcFee', label: '过路费' },
          { prop: 'freightFee', label: '运费（现金）' },
          { prop: 'otherFee', label: '其他订单费' },
          { prop: 'salaryFee', label: '司机工资' },
          { prop: 'fixedFee', label: '车辆固定费用' },
          { prop: 'vmaintenanceFee', label: '车辆维护费用' },
          { prop: 'grossMargin', label: '毛利' },
          { prop: 'grossProfitMargin', label: '毛利率' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: vehicleMonthlyReport,

    switchShowData () {
      this.showChart = !this.showChart;
      this.$emit('getChartData');
    },

    // 获取图表数据
    async getChartData (data, config = {}) {
      const res = await vehicleMonthlyReport({
        page: 1,
        // TODO 本来要全部返回，为了快速完成功能所以一次性查10000个
        rows: 10000,
        ...data,
        sts: true,
      });
      let resData = [];
      if (!res.failed) {
        if (res.items && res.items.length) {
          resData = res.items;
        }
      }
      return resData;
    },

    // 提供给外部调用的方法，填入数据
    async setLineChartData (data) {
      this.searchData = data;
      if (this.showChart) {
        const resData = await this.getChartData(data);
        if (data.mode === 1) {
          // 部门对比
          this.setChartData('org', this.handleChartData(resData, 'orgName'));
        }
        if (data.mode === 2) {
          // 月份对比
          this.setChartData('month', this.handleChartData(resData, 'dependTime'));
        }
      }
    },

    /**
     * @param {Object} data       返回的列表数据
     * @param {String} fieldName  围绕着哪个字段来处理数据，如果是 部门对比 ，则是 orgName，月份对比是 dependTime
     * @returns {Object}  返回处理好的图表数据
     * @description 将返回的列表数据格式 转化成 图表数据所需的格式
     */
    handleChartData (data, fieldName) {
      let json = {};
      for (let item of data) {
        Object.keys(item).forEach((itemName) => {
          if (item[fieldName]) {
            let targetItem = item[fieldName] + '_' + itemName;
            if (!json[targetItem]) {
              // 如果没有该月份，则设置一个该月/该部门的属性
              if (!isNaN(Number(item[itemName]))) {
                json[targetItem] = Number(item[itemName]) * 1000;
              }
            } else {
              // 如果已存在，则累加
              if (!isNaN(Number(item[itemName]))) {
                json[targetItem] += Number(item[itemName]) * 1000;
              }
            }
          }
        });
      }

      // 月份/部门
      const xAxisData = [];
      // 各种类型
      const seriesData = [
        { type: 'line', prop: 'orderNum', name: '订单数量', data: [], select: true },
        { type: 'line', prop: 'incomeFee', name: '订单收入（元）', data: [], select: false },
        { type: 'line', prop: 'orderCost', name: '订单成本（元）', data: [], select: false },
        { type: 'line', prop: 'oilFee', name: '油费', data: [], select: false },
        { type: 'line', prop: 'etcFee', name: '过路费', data: [], select: false },
        { type: 'line', prop: 'freightFee', name: '运费（现金）', data: [], select: false },
        { type: 'line', prop: 'otherFee', name: '其他订单费', data: [], select: false },
        { type: 'line', prop: 'salaryFee', name: '司机工资', data: [], select: false },
        { type: 'line', prop: 'fixedFee', name: '车辆固定费用', data: [], select: false },
        { type: 'line', prop: 'vmaintenanceFee', name: '车辆维护费用', data: [], select: false },
        { type: 'line', prop: 'grossMargin', name: '毛利', data: [], select: false },
        { type: 'line', prop: 'grossProfitMargin', name: '毛利率', data: [], select: false },
      ];

      for (let name in json) {
        if (name && !isNaN(json[name])) {
          const targetName = name.split('_')[0];
          if (!xAxisData.includes(targetName)) {
            // 月份
            xAxisData.push(targetName);
          }
          for (let seriesItem of seriesData) {
            if (name.includes(seriesItem.prop)) {
              // 每一项的数据
              seriesItem.data.push((json[name] / 1000).toFixed(2));
            }
          }
        }
      }

      // 筛选项
      const legendData = seriesData.map((item) => item.name);
      // 默认选中哪个显示项
      let legendSelect = {};
      seriesData.forEach((item) => {
        legendSelect[item.name] = item.select;
      });

      return {
        xAxisData,
        legendData,
        legendSelect,
        seriesData,
      };
    },

    // 设置图表数据用于渲染展示
    setChartData (chartName, chartData) {
      const options = {
        isShowCustomData: true,
        xAxis: {
          type: 'category',
          data: chartData.xAxisData,
        },
        // 图表位置
        grid: {
          left: '10%',
          right: '15%',
          bottom: '10%',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: chartData.legendData,
          orient: 'vertical',
          x: 'right',
          y: 'center',
          selected: chartData.legendSelect,
          textStyle: {
            fontSize: 14,
          },
          itemGap: 12,
        },
        yAxis: {
          type: 'value',
        },
        series: chartData.seriesData,
      };
      this.$refs[chartName].setOptions(options);
    },

    // 设置图表的宽度
    setChartWidth () {
      const placeholderDiv = document.getElementById('placeholderDiv');
      this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      window.onresize = () => (() => {
        this.placeholderDiv = placeholderDiv ? placeholderDiv.offsetWidth : 0;
      })();
    },
  },
  mounted () {
    this.setChartWidth();
  },
};
</script>

<style lang="scss" scoped>
</style>
